export enum ThemeColors {
  INDIGO = "indigo",
  PINK = "pink",
  PURPLE = "purple",
  WHITE = "white",
  GREY = "grey",
  BLACK = "black",
  MANDARINE = "mandarine",
  BLUE = "blue",
  GREEN = "green",
}
